import styled from 'styled-components'

export const ModalOverlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 9999;
`

export const ModalWrapper = styled.div`
  background: white;
  padding: 30px;
  border-radius: 8px;
  min-width: 450px;
  max-width: 736px;
  width: 100%;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.2);
  display: flex;
  flex-direction: column;
`

export const Header = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  border-bottom: 1px dashed #ccc;
  padding-bottom: 10px;

  h3 {
    margin: 0;
    padding: 10px 0;
  }
`

export const ProductHeader = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 0.5rem;
  margin-bottom: 10px;

  .h3 {
    font-size: 11px !important;
    margin: 0 !important;
    padding: 0 !important;
    border: 0 !important;
    width: 32vw !important;
    white-space: normal !important;
  }
`

export const ProductInfo = styled.div`
  display: flex;
  align-items: center;
  gap: 0.75rem;
  min-width: 0;
  width: 100%;
  margin-top: 15px;
`

export const ProductImage = styled.img`
  width: 3vw !important;
`

export const ProductName = styled.span`
  font-weight: 500;
  font-size: 14px;
  line-height: 1.4;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  display: block;
  max-width: 100%;
  font-family: inherit;
`

export const BackButton = styled.div`
  ${({ theme }) => `
    mask-image: url(${process.env.REACT_APP_URL_MAIN}/Images/new-layout-gimba/icons/icon-close.svg);
    -webkit-mask-image: url(${process.env.REACT_APP_URL_MAIN}/Images/new-layout-gimba/icons/icon-close.svg);
  `}
  mask-size: contain;
  -webkit-mask-size: contain;
  mask-repeat: no-repeat;
  -webkit-mask-repeat: no-repeat;
  width: 20px;
  height: 20px;
  background-color: #707070;
  cursor: pointer;
`

export const StarsContainer = styled.div`
  display: flex;
  align-items: center;
  align-self: flex-end;
`

export const StarIcon = styled.div`
  font-size: 30px;
  color: ${({ $active }) => ($active ? '#ffc107' : '#ccc')};
  cursor: pointer;
  margin: 0 5px;
  transition: color 0.2s;
`

export const TextArea = styled.textarea`
  width: 100%;
  border-radius: 5px;
  border: 1px solid #ccc;
  resize: none;
  font-size: 14px;
  padding: 20px;
  margin-bottom: 20px;
  height: 130px;
  caret-color: #000;
  font-family: inherit;

  cursor: text;

  &:not(:focus) {
    caret-color: transparent;
  }
`

export const SubmitButton = styled.button`
  background-color: #4caf50;
  color: white;
  border: none;
  padding: 10px 20px;
  width: 158px;
  height: 38px;
  font-size: 14px;
  border-radius: 4px;
  cursor: pointer;
  font-family: inherit;
  transition: background-color 0.2s;
  margin-left: auto;

  &:hover {
    background-color: #45a049;
  }
  &:disabled {
    background-color: #a5d6a7;
    cursor: not-allowed;
  }
`
export const CharLimitText = styled.div`
  align-self: flex-end;
  font-size: 10px;
  color: #333;
  margin-top: -15px;
  margin-bottom: 10px;
  margin-right: 2px;
`
